import { IFailedTempPlannedPortfolio } from './../../models/plannedPortfolios';
import { EntityState } from '@ngrx/entity';
import { IPlannedPortfolio } from 'src/app/models/plannedPortfolios';
import { IModelPortfolioDataError, IModelPortfolioOrder } from './../../models/modelPortfolios';
import { IModelPortfolio } from "src/app/models/modelPortfolios";
import { modelPortfolioAdapter } from '../model-portfolios/selectors/model-portfolios.selectors';

export interface IModelPortfoliosState extends EntityState<IModelPortfolio>  {
    selectedModelPortfolioId: number;
    submittedModelPortfolio?: IModelPortfolio;
    lastSavedModelPortfolio?: IModelPortfolio;
    loading: boolean;
    isModelPortfolioUpdated: boolean;
    modelPortfolioSubmittedSuccess: boolean;
    modelPortfolioSubmittedSuccessText: string;
    modelPortfolioSubmittedFail: boolean;
    modelPortfolioPositionUpdatedSuccess: boolean;
    modelPortfolioPositioUpdatedSuccessText: string;
    modelPortfolioPositioUpdatedFail: boolean;
    modelPortfolioPositioUpdatedFailText: string;
    modelPortfolios?: any;
    selectedModelPortfolioPosition?: any;
    isModelPortfolioSubmitted?: boolean;
    modelPortfolioPositionDeletedSuccess: boolean;
    modelPortfolioPositionDeletedSuccessText: string;
    modelPortfolioDeletedSuccess: boolean;
    modelPortfolioDeletedSuccessText: string;
    plannedPortfolios: IPlannedPortfolio[];
    rebalancedPlannedPortfolios: IPlannedPortfolio[];
    selectedTempPlannedPortfolio: IPlannedPortfolio;
    modelPortfolioDataError: IModelPortfolioDataError;
    isInitialState: boolean;
    lastSubmittedModelPortfolioId: number;
    failedTempPlannedPortfolios: IFailedTempPlannedPortfolio[];
    modelPortfoliosOrders: IModelPortfolioOrder[];
    subscriberCashSummaries: any[];
}

export const initialModelPortfoliosState: IModelPortfoliosState = modelPortfolioAdapter.getInitialState({
    selectedModelPortfolioId: null,
    lastSavedModelPortfolio: null,
    loading: false,
    isModelPortfolioUpdated: false,
    modelPortfolioSubmittedSuccess: false,
    modelPortfolioSubmittedSuccessText: '',
    modelPortfolioSubmittedFail: false,
    modelPortfolioPositionUpdatedSuccess: false,
    modelPortfolioPositioUpdatedSuccessText: '',
    modelPortfolioPositioUpdatedFail: false,
    modelPortfolioPositioUpdatedFailText: '',
    modelPortfolios: null,
    selectedModelPortfolioPosition: null,
    isModelPortfolioSubmitted: false,
    modelPortfolioPositionDeletedSuccess: false,
    modelPortfolioPositionDeletedSuccessText: '',
    modelPortfolioDeletedSuccess: false,
    modelPortfolioDeletedSuccessText: '',
    plannedPortfolios: [],
    rebalancedPlannedPortfolios: [],
    selectedTempPlannedPortfolio: null,
    modelPortfolioDataError: null,
    isInitialState: true,
    lastSubmittedModelPortfolioId: null,
    failedTempPlannedPortfolios: [],
    modelPortfoliosOrders: [],
    subscriberCashSummaries: [],
});
